import React from "react";
import { ThreeDots } from "react-loader-spinner";

const ThreeDot = () => {
  return (
    <ThreeDots
      visible={true}
      height="20"
      width="20"
      color="#ffffff"
      radius="9"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClass=""
    />
  );
};

export default ThreeDot;
